import {getColorByPath} from 'platform/foundation';
import {useTheme} from 'styled-components';

import {ABC_XYZ_CHART_COLORS} from '../constants/ABC_XYZ_CHART_COLORS';

export function useAbcXyzChartColors(): Record<keyof typeof ABC_XYZ_CHART_COLORS, string> {
  const theme = useTheme();

  return {
    primary: getColorByPath(ABC_XYZ_CHART_COLORS.primary, theme)!,
    accent: getColorByPath(ABC_XYZ_CHART_COLORS.accent, theme)!,
    highlight: getColorByPath(ABC_XYZ_CHART_COLORS.highlight, theme)!,
  };
}
